export default __webpack_public_path__ + "static/media/Knob_DHK401.bacff89d.obj";